import * as React from 'react';
import { ActorApiStringDisplay } from '../../../../../../components/display/string';
import { useAccountDocumentsArDocDescription } from '../../hooks';

export const AccountsDocumentsArDocDescription = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountDocumentsArDocDescription();
  return (
    <ActorApiStringDisplay
      data={data}
      isLoading={isLoading}
      error={error}
    />
  );
};
